import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOneBanner, updateBanner } from 'slice/bannerSlice'; // Import your action creator to fetch a single product
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';

const UpdateBanner = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, data } = useSelector((state) => state.banner);
    const [formData, setFormData] = useState({
        heading: '',
        sub_heading: '',
        image: null,
        is_active: 1
    });

    useEffect(() => {
        dispatch(getOneBanner(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (data) {
            setFormData({
                heading: data.heading || '',
                sub_heading: data.sub_heading || '',
                is_active: data.is_active ?? 1,
                image: null // Don't put the image path in the file input
            });
        }
    }, [data]);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('heading', formData.heading);
            formDataToSend.append('sub_heading', formData.sub_heading);
            formDataToSend.append('is_active', formData.is_active);
            if (formData.image) {
                formDataToSend.append('image', formData.image);
            }

            dispatch(updateBanner({ id: id, data: formDataToSend }))
            toast.success('Banner updated successfully!');
            navigate('/banner')

        } catch (error) {
            console.error('There was a problem updating the banner:', error.message);
            toast.error('Failed to update banner');
        }
    };

    return (
        <>
            <div className='container card my-5 p-4 bg-dark text-white'>
                <h4 className="mb-4">Update Banner</h4>
            <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className='col-sm-6 mt-2'>
                        <label htmlFor='bannerHeading'>Banner Heading</label>
                        <input type='text' id='bannerHeading' name='heading' value={formData.heading} className='form-control' placeholder="Update heading" onChange={handleChange} required />
                    </div>
                    <div className='col-sm-6 mt-2'>
                        <label htmlFor='bannerSubHeading'>Banner Sub Heading</label>
                        <input type='text' id='bannerSubHeading' name='sub_heading' value={formData.sub_heading} className='form-control' placeholder="Update sub-heading" onChange={handleChange} />
                    </div>
                    <div className='col-sm-6 mt-3'>
                        <label htmlFor='is_active'>Status</label>
                        <select id='is_active' name='is_active' value={formData.is_active} className='form-control' onChange={handleChange}>
                            <option value={1}>Active</option>
                            <option value={0}>Inactive</option>
                        </select>
                    </div>
                    <div className='col-sm-6 mt-3'>
                        <label htmlFor='bannerImage'>Banner Image (Leave blank to keep current)</label>
                        <input type='file' id='bannerImage' name='image' className='form-control btn-block filebg' onChange={handleChange} />
                    </div>
                </div>
                <div className='mt-4 text-right'>
                    <button className='btn btn-success' disabled={loading}>
                        {loading ? 'Updating...' : 'Update Banner'}
                    </button>
                </div>
            </form>
        </div >
        </>
    )
}

export default UpdateBanner;